<template>
    <div :class="classes" class="panel">
        <div class="panel-wrapper">
            <div class="panel-content">
                <div v-if="hasTitleSlot || hasButtonsSlot" class="panel-header">
                    <div class="panel-title">
                        <div class="visuallyhidden">
                            <slot name="page-title" />
                        </div>
                        <slot name="title" />
                        <slot name="tag" />
                    </div>
                    <div class="panel-spacer" />
                    <div class="panel-buttons">
                        <slot name="buttons" />
                    </div>
                </div>
                <div v-if="!noBody" class="panel-body">
                    <slot />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'panel',
    props: {
        size: {
            type: String,
            default: 'col-24'
        },
        noBody: {
            type: Boolean,
            default: false
        },
        isHeader: {
            type: Boolean,
            default: false
        },
        wrapButtons: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        classes () {
            return [ 
                this.size, 
                { 
                    'no-body': this.noBody,
                    'is-header': this.isHeader,
                    'wrap-buttons': this.wrapButtons
                }
            ]
        },
        hasTitleSlot () {
            return !!this.$slots['title']
        },
        hasButtonsSlot () {
            return !!this.$slots['buttons']
        }
    }
}
</script>

<style lang="stylus">
@import '../../stylus/variables'
.panel
    padding: 0 10px
    flex-shrink: 0
    flex-grow: 1
    &:first-child
        padding-left: 0px
    &:last-child
        padding-right: 0px
    &.no-body .panel-header
        border-bottom-width: 0px
    &.is-header
        .panel-wrapper
            background: transparent
            box-shadow: none
            .panel-header
                padding: 15px 0px
    .panel-wrapper
        background-color: $white
        border-radius: 12px
        box-shadow: 0 5px 20px rgba(0, 0, 0, .08)
        padding: 5px 20px 0
        display: flex
        @media screen and (max-width: 1024px)
            padding: 5px 10px 0
    .panel-header
        margin-left: -20px
        margin-right: -20px
        margin-top: -5px
        padding: 15px 20px 15px 20px
        border-bottom: 1px solid $light-border-color
        display: flex
        @media screen and (max-width: 1024px)
            margin: -5px -10px 0

        .panel-spacer
            flex-grow: 1
        .panel-title
            display: flex
            align-items: center
            h2, h3
                padding: 5px 0 5px 0px
                margin: 2px 0 0 0px
                font-weight: 700
                color: $text-dark-grey
                letter-spacing: 1px
                font-size: 18px
                line-height: 20px
        .panel-buttons
            margin-top: 0px
            margin-bottom: 0px
            display: flex
            > *
                margin-left: 10px
    @media screen and (max-width: 640px)
        &.wrap-buttons .panel-header
            display: block
            .panel-buttons 
                margin-top: 5px;
                *:first-child
                    margin-left: 0px
    .panel-tabs
        display: flex
        margin: -20px -20px 0 -20px
    .panel-body
        padding-bottom: 20px
        .info-bar
            margin: 0px -40px -20px
            border-bottom: 0px
    .panel-content
        width: 100%
    .panel-menu
        flex-shrink: 0
        padding-right: 40px
        margin-left: -10px
        margin-top: -20px

    &.col-1 { width: 4.1666% }
    &.col-2 { width: 8.3333% }
    &.col-3 { width: 12.5% }
    &.col-4 { width: 16.6666% }
    &.col-5 { width: 20.8333% }
    &.col-6 { width: 25% }
    &.col-7 { width: 29.1666% }
    &.col-8 { width: 33.3333% }
    &.col-9 { width: 37.5% }
    &.col-10 { width: 41.6666% }
    &.col-11 { width: 45.8333% }
    &.col-12 { width: 50% }
    &.col-13 { width: 54.1666% }
    &.col-14 { width: 58.3333% }
    &.col-15 { width: 62.5% }
    &.col-16 { width: 66.6666% }
    &.col-17 { width: 70.8333% }
    &.col-18 { width: 75% }
    &.col-19 { width: 79.1666% }
    &.col-20 { width: 83.3333% }
    &.col-21 { width: 87.5% }
    &.col-22 { width: 91.6666% }
    &.col-23 { width: 95.8333% }
    &.col-24 { width: 100% }

    @media screen and (max-width: 480px)
        &.col-1, &.col-2, &.col-3, &.col-4,
        &.col-5, &.col-6, &.col-7, &.col-8,
        &.col-9, &.col-10, &.col-11, &.col-12,
        &.col-13, &.col-14, &.col-15, &.col-16,
        &.col-17, &.col-18, &.col-19, &.col-20,
        &.col-21, &.col-22, &.col-23, &.col-24
            width: 100%
            margin-bottom: 20px
        &:first-child
            padding-left: 10px
        &:last-child
            padding-right: 10px
</style>
